if (!window.pingInit) window.pingInit = {};
window.pingInit.initFooterSection = (context) => {
  const footerSection = context.closest('.shopify-section');
  if (!footerSection) return;

  footerSection.querySelectorAll('.footer__main-content__newsletter__custom-form').forEach(customNewsletterContainer => {
    const emailField = customNewsletterContainer.querySelector('input[type="email"]');
    if (emailField) {
      emailField.addEventListener('click', () => {
        customNewsletterContainer.classList.add('open');
      });
    }
  });
};

if (document.readyState != "loading") {
  [].forEach.call(
    document.querySelectorAll(".site-footer"),
    (el) => {
      window.pingInit.initFooterSection(el);
    }
  );
} else {
  document.addEventListener("DOMContentLoaded", () => {
    [].forEach.call(
      document.querySelectorAll(".site-footer"),
      (el) => {
        window.pingInit.initFooterSection(el);
      }
    );
  });
}
